import React from "react";
import { Link, useHistory, useLocation } from 'react-router-dom';

import Menu from "../Menu";
import "./style.scss";
import ConfigData from '../../config.json';

const Header = () => {
    const history = useHistory();
    const location = useLocation();
    const handleRoutes = path => {
      history.push({ pathname: path, search: location.search });
    };
    return (
        <div className="header-wrap">
            <p className="brand-description">
                <Link to={'/'} onClick={() => handleRoutes('/')}>
                    <img src={ConfigData.logo.path} alt={ConfigData.logo.alt} width={50} />
                </Link>
            </p>
            <Menu />
        </div>
    );
}

export default Header;